import {
  FormField,
  Modal,
  Select,
  SpaceBetween,
  TextContent,
} from '@amzn/awsui-components-react-v3';
import React, { ReactElement, useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { GET_CMS_LIST_SITES } from '../../services/container-management/queries';
import { sortOptions } from '../../utils/ContainerManagement/containerDefinitionsHelper';

export function transformDataForDropdown(locationResponse: any): any {
  const locationData: { label: any; value: any; locationId: any }[] = [];
  Object.keys(locationResponse).forEach((loc) => {
    locationData.push({
      label: locationResponse[loc].locationName,
      value: locationResponse[loc].locationName,
      locationId: locationResponse[loc].locationId,
    });
  });
  return locationData;
}

const UserPreference = (): ReactElement => {
  const { t } = useTranslation();
  const [selectedSiteOption, setSelectedSiteOption] = useState(null);
  const [modalVisible, setModalVisible] = useState(true);
  const [locations, setLocations] = useState([]);

  const { loading, error } = useQuery(GET_CMS_LIST_SITES, {
    variables: {},
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
    onCompleted: (result) => {
      setLocations(transformDataForDropdown(result.listSites.locations));
    },
  });

  const validateCookie = () => {
    if (localStorage.getItem('siteId')) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      setSelectedSiteOption(JSON.parse(localStorage.getItem('siteId')!));
      setModalVisible(false);
    }
  };
  const handleSiteChange = (obj: any) => {
    setSelectedSiteOption(obj);
    localStorage.setItem('siteId', JSON.stringify(obj));
    setModalVisible(false);
    window.location.reload();
  };

  useEffect(() => {
    validateCookie();
  }, []);

  return (
    <Modal visible={modalVisible} closeAriaLabel="Close modal" header="Set Preferred Site">
      <SpaceBetween direction="vertical" size="s">
        <FormField>
          <TextContent>
            <h5>
              {t('container-management.site')}
              <i className="red-text">*</i>
            </h5>
          </TextContent>
        </FormField>
        <FormField>
          <Select
            selectedOption={selectedSiteOption}
            name="siteDropdownModal"
            onChange={({ detail }) => handleSiteChange(detail.selectedOption)}
            options={sortOptions(locations)}
            placeholder="Choose an option"
            selectedAriaLabel="Selected"
            empty="No options"
            // eslint-disable-next-line no-nested-ternary
            statusType={loading ? 'loading' : error ? 'error' : 'finished'}
          />
        </FormField>
      </SpaceBetween>
    </Modal>
  );
};

export default UserPreference;
